import { useEffect, useState } from "react";

// Aligné sur le breakpoint `md` de Tailwind (768px).
const MOBILE_QUERY = "(max-width: 767px)";

/** Vrai sur les petits écrans. Réactif au redimensionnement / rotation. */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
